// extracted by mini-css-extract-plugin
export default {"sort":"JO-z","sortSelect":"KO-z","disabled":"LO-z"};